import { useState } from "react";
import { Link } from "react-router-dom";
import { useFetch, fmtDay } from "../lib/api";
import { Card, Empty, ExportButtons, PageHeader, Sel, ScorePill } from "../components/common";

export default function Companies() {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  const { data } = useFetch(`/companies?q=${encodeURIComponent(q)}&category=${encodeURIComponent(cat)}`);
  return (
    <div>
      <PageHeader title="Companies" subtitle="De-duplicated organisations discovered across all sources.">
        <ExportButtons rows={data} name="companies" />
      </PageHeader>
      <div className="mb-4 flex flex-wrap gap-2">
        <input data-testid="companies-search" className="dm-input w-72" placeholder="Search company…" value={q} onChange={(e) => setQ(e.target.value)} />
        <Sel testid="companies-category" value={cat} onChange={setCat} placeholder="All categories" options={["Direct client", "Consulting / delivery partner"]} />
      </div>
      <Card>
        {!data?.length ? <Empty text="No companies yet. Run discovery or add a manual lead." testid="companies-empty" /> : (
          <div className="overflow-x-auto"><table className="dm-table w-full">
            <thead><tr><th>Company</th><th>Category</th><th>Countries</th><th>Sources</th><th className="text-right">Opportunities</th><th className="text-right">Best score</th><th>First seen</th></tr></thead>
            <tbody>{data.map((c) => (
              <tr key={c.id} data-testid={`company-row-${c.id}`}>
                <td><Link className="font-medium text-blue-700 hover:underline" to={`/admin/companies/${c.id}`}>{c.name}</Link></td>
                <td className="text-xs">{c.category}</td><td className="text-xs">{(c.countries || []).join(", ")}</td>
                <td className="text-xs">{(c.sources || []).join(", ")}</td>
                <td className="text-right font-mono">{c.opportunity_count}</td><td className="text-right"><ScorePill score={c.best_score} /></td>
                <td className="text-xs">{fmtDay(c.created_at)}</td>
              </tr>))}</tbody>
          </table></div>)}
      </Card>
    </div>
  );
}
